import React, { Component } from "react";

// Higher-Order Component to inject window dimensions as props
function withWindowDimensions(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
      this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
      window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.handleResize);
    }

    handleResize() {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    render() {
      return <WrappedComponent {...this.props} windowDimensions={this.state} />;
    }
  };
}

class BenefitsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTier: 0,
    };
  }

  handlePrevTier = () => {
    const { headers } = this.props.data;
    this.setState((prevState) => ({
      currentTier: prevState.currentTier > 0 ? prevState.currentTier - 1 : prevState.currentTier,
    }));
  };

  handleNextTier = () => {
    const { headers } = this.props.data;
    this.setState((prevState) => ({
      currentTier: prevState.currentTier < headers.length - 1 ? prevState.currentTier + 1 : prevState.currentTier,
    }));
  };

  render() {
    const { data, windowDimensions } = this.props;
    const { width } = windowDimensions;
    const isDesktop = width > 1199;
    const { headers, tiers } = data;
    const { currentTier } = this.state;

    return (
      <div className="benefits-table">
        <div className="table-header">
          <div className="header-content">
            <h2
              style={{
                color: (data && data.title && data.title.color) || "#000",
                backgroundColor: (data && data.tableHeaderBackground) || "#fff",
              }}
            >
              {(data && data.title && data.title.label) || ""}
            </h2>
            {isDesktop ? (
              headers.map((header, index) => (
                <h3
                  key={index}
                  style={{
                    color: (header && header.color) || "#000",
                    backgroundColor: (data && data.tableHeaderBackground) || "#fff",
                  }}
                >
                  {(header && header.label) || ""}
                </h3>
              ))
            ) : (
              <div
                className="tier-navigation"
                style={{ backgroundColor: (data && data.tableHeaderBackground) || "#fff" }}
              >
                <button
                  className="nav-button prev"
                  onClick={this.handlePrevTier}
                  disabled={currentTier <= 0}
                >
                  <i className="icon-button-arrow-prev" aria-hidden="true" />
                </button>
                <h3
                  style={{
                    color: (headers[currentTier] && headers[currentTier].color) || "#000",
                  }}
                >
                  {(headers[currentTier] && headers[currentTier].label) || ""}
                </h3>
                <button
                  className="nav-button next"
                  onClick={this.handleNextTier}
                  disabled={currentTier >= headers.length - 1}
                >
                  <i className="icon-button-arrow-next" aria-hidden="true" />
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="table-wrapper">
          <table>
            <tbody>
              {(tiers || []).map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  style={{ backgroundColor: (row && row.rowBackgroundColor) || "#fff" }}
                >
                  <td
                    className="benefit-cell"
                    style={{ color: "#373737" }}
                  >
                    {row && row.benefit}
                  </td>
                  {isDesktop ? (
                    (row && row.values ? row.values : []).map((value, index) => (
                      <td key={index} style={{ color: (value && value.color) || "#000" }}>
                        {value && value.text}
                      </td>
                    ))
                  ) : (
                    <td
                      style={{
                        color:
                          (row &&
                            row.values &&
                            row.values[currentTier] &&
                            row.values[currentTier].color) ||
                          "#000",
                      }}
                    >
                      {(row &&
                        row.values &&
                        row.values[currentTier] &&
                        row.values[currentTier].text) ||
                        ""}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default withWindowDimensions(BenefitsTable);
